import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import Structure from '@Components/Results/structure/Structure';
import { ButtonWithIcon } from '@els/els-react--button';
import ReactReactionAdditionalInfoHelper from '@Components/Results/services/react-reaction-additional-info-helper.service';
import StructureModel from '@Components/Results/structure/structure-model.service';
import cn from 'classnames';
import isString from 'lodash/isString';

const stripSurroundingHiTag = (refCount) => (isString(refCount) ? refCount.replace(/<hi>(.*?)<\/hi>/, '$1') : refCount);

export default function SynthesisPlannerSimilarityReaction(props) {
  const { reaction, submit, className, hideSimilarityColumn = false } = props;
  const isCIDatabase = ReactReactionAdditionalInfoHelper.isCIDatabase(reaction.databaseId);

  return (
    <div className={cn('rx-list-item border-row', className)}>
      <article className="rx-element rx-element--reaction clearfix">
        <div className={cn(`col-similarity-reaction-${hideSimilarityColumn ? 5 : 3}`, 'text-center')}>
          <Structure structure={new StructureModel(reaction)} metadata={{}} zoom={1} showToolbar={false} />
          <div className="substance-image__under">
            <ButtonWithIcon
              type="tertiary"
              size="small"
              sprite="ChevronRight"
              onClick={() => submit(reaction)}
              className={`e2e-submit-reaction-${reaction.index}`}>
              Submit
            </ButtonWithIcon>
          </div>
        </div>

        {!hideSimilarityColumn && (
          <div className="col-similarity-reaction-2 text-center">
            <span>{reaction?.similarityPercentage != null && reaction.similarityPercentage / 10} %</span>
          </div>
        )}

        <div className="col-similarity-reaction-3 text-center">
          <InnerHTML tag="span" html={reaction?.details?.chemicalNames && reaction?.details?.chemicalNames?.slice(0, 10)?.join(', ')} />
        </div>

        <div className="col-similarity-reaction-2 text-center">
          {!isCIDatabase && <span>{stripSurroundingHiTag(reaction?.details?.referencesCount)}</span>}
        </div>

        <div className="col-similarity-reaction-2 text-center">
          <span>{reaction?.links?.preparationsCount}</span>
        </div>
      </article>
    </div>
  );
}

SynthesisPlannerSimilarityReaction.propTypes = {
  reaction: PropTypes.object.isRequired,
  submit: PropTypes.func.isRequired,
  className: PropTypes.string,
  hideSimilarityColumn: PropTypes.bool,
};
